import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { mediaUrl } from '../../api/client';
import { fetchCollection } from '../../api/collections';

export default function CollectionPage() {
  const { handle } = useParams();
  const [collection, setCollection] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setCollection(null);
    setError(null);
    fetchCollection(handle)
      .then(({ collection: data }) => {
        if (!cancelled) setCollection(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Failed to load collection.');
      });
    return () => {
      cancelled = true;
    };
  }, [handle]);

  if (error) {
    return (
      <div className="collection-page">
        <p className="collection-error">{error}</p>
        <Link className="btn-info" to="/">Back home</Link>
      </div>
    );
  }

  if (!collection) {
    return <div className="collection-page" />;
  }

  return (
    <div className="collection-page">
      <header className="collection-header">
        <h1 className="collection-title">{collection.title}</h1>
        {collection.description && <p className="collection-desc">{collection.description}</p>}
      </header>

      {collection.products.length === 0 ? (
        <p className="collection-empty">No products in this collection yet.</p>
      ) : (
        <div className="product-grid">
          {collection.products.map((product) => (
              <article className="product-card" key={product.id} >
              {product.portrait_url && (
                <img className="product-portrait" src={mediaUrl(product.portrait_url)} alt={product.title} />
              )}
              <h3 className="product-title">{product.title}</h3>
              {product.description && <p className="product-desc">{product.description}</p>}
              {product.buy_button && (
                <div className="product-buy" dangerouslySetInnerHTML={{ __html: product.buy_button }} />
              )}
                 <Link
              className="nav-btn nav-btn-faves"
              to={`/products/${product.title}`}
              title="See Product!"
            >
              &#9733; See Product
            </Link>
            </article>

          ))}
        </div>
      )}
    </div>
  );
}